import React from 'react';
import { Mui } from '@osu/react-ui';
import StudentListItem from './StudentListItem';

/**
 * SearchResults Component
 * Displays search results, no results message, or initial state
 */
function SearchResults({
  hasSearched,
  searchResults,
  selectedStudent,
  showLoadingIndicator,
  debouncedSearchQuery,
  onStudentSelect,
  onKeyDown,
  searchQuery
}) {
  // Show search results when we have searched
  if (hasSearched) {
    return (
      <Mui.Box>
        {searchResults.length > 0 ? (
          <>
            <Mui.Typography variant="subtitle2" sx={{ mb: 1 }}>
              Search Results ({searchResults.length} found)
            </Mui.Typography>
            
            <Mui.List 
              role="listbox"
              aria-label="Student search results"
              sx={{ 
                border: '1px solid #e0e0e0',
                borderRadius: 1,
                maxHeight: 400,
                overflow: 'auto'
              }}
            >
              {searchResults.map((student, index) => (
                <StudentListItem
                  key={student.id}
                  student={student}
                  selectedStudent={selectedStudent}
                  onStudentSelect={onStudentSelect}
                  onKeyDown={onKeyDown}
                  isLast={index === searchResults.length - 1}
                />
              ))}
            </Mui.List>
          </>
        ) : (
          // Only show "no results" if we're not currently loading and have actually searched
          !showLoadingIndicator && (
            <Mui.Alert severity="info">
              No students found matching "{debouncedSearchQuery}". Try a different search term.
            </Mui.Alert>
          )
        )}
      </Mui.Box>
    );
  }

  // Return null for other states (no results to show)
  return null;
}

export default SearchResults;